<template>
  <div class="event">
    <EventForm
      :visible="visible"
      v-if="visible"
      :event="event"
      @cancel="hideForm"
      @create="hideForm"
    />
    <Header class="event__header" @change="changeTab" />
    <a-card
      style="margin-top: 24px"
      :bordered="false"
      title="事件列表"
      class="event-view-card"
    >
      <div slot="extra">
        <a-radio-group v-model="status">
          <a-radio-button value="all">全部</a-radio-button>
          <a-radio-button value="processing">使用中</a-radio-button>
          <a-radio-button value="active">已归档</a-radio-button>
        </a-radio-group>
        <a-input-search
          style="margin-left: 16px; width: 272px;"
          placeholder="搜索事件名、缩写和描述"
          v-model="search"
        />
      </div>

      <div class="operate">
        <a-button
          type="dashed"
          style="width: 100%"
          icon="plus"
          @click="showForm"
          >添加</a-button
        >
      </div>

      <a-list
        size="large"
        :pagination="pagination"
        :data-source="events"
        :locale="{ emptyText: '暂无事件' }"
      >
        <a-list-item slot="renderItem" slot-scope="item">
          <a-list-item-meta :description="item.abbr">
            <!-- <a-avatar
              slot="avatar"
              size="large"
              shape="square"
              :src="item.avatar"
            /> -->
            <span v-if="item.icon" slot="title" style="margin-right:.5rem;">{{
              item.icon
            }}</span>
            <a slot="title">{{ item.name }}</a>
          </a-list-item-meta>
          <div slot="actions">
            <a @click="handleEdit(item)">编辑</a>
          </div>
          <div slot="actions">
            <a-dropdown>
              <a-menu slot="overlay">
                <a-menu-item
                  ><a @click="handleArchive(item.id)">{{
                    item.active ? "归档" : "还原"
                  }}</a></a-menu-item
                >
                <a-menu-item
                  ><a @click="handleDel(item.id)">删除</a></a-menu-item
                >
              </a-menu>
              <a>更多<a-icon type="down"/></a>
            </a-dropdown>
          </div>
          <div class="list-content">
            <div class="list-content-item">
              <div class="list-content-description">
                {{ item.description }}
              </div>
            </div>
            <div class="list-content-item">
              <div class="list-content-tag" @click="handleArchive(item.id)">
                <a-tag v-if="item.active" color="blue">
                  使用中
                </a-tag>
                <a-tag v-else color="orange">
                  已归档
                </a-tag>
              </div>
            </div>
          </div>
        </a-list-item>
      </a-list>
    </a-card>
  </div>
</template>

<script>
import Header from "./components/EventHeader";
import EventForm from "./components/EventForm";
import { mapActions } from "vuex";

// import { mapGetters } from "vuex";

export default {
  components: {
    Header,
    EventForm
  },
  data() {
    return {
      pagination: {
        pageSize: 8,
        hideOnSinglePage: true
      },
      status: "all",
      visible: false,
      event: {},
      search: ""
    };
  },

  methods: {
    changeTab(activeKey) {
      this.showActive = activeKey === "active" ? true : false;
    },
    handleDel(id) {
      this.$modal.confirm({
        title: "确定要删除这个事件吗？",
        content: "删除事件的同时也将会从记录该事件的时块上删除事件",
        okText: "删除",
        okType: "danger",
        cancelText: "取消",
        onOk: () => {
          this.deleteEvent(id);
        }
      });
    },
    handleEdit(event) {
      this.event = event;
      this.visible = true;
    },
    handleArchive(id) {
      this.toggleArchiveEvent(id);
      if (this.$store.getters.events[id].active) {
        this.$message.success("归档成功");
      } else {
        this.$message.success("还原成功");
      }
    },
    showForm(event) {
      if (event.screenX + event.screenY + event.clientX + event.clientY === 0)
        return; //莫名奇妙的会自动触发click，导致表单重新出现,通过点击位置判断是否为自动触发的
      this.visible = true;
    },
    hideForm() {
      this.event = null;
      this.visible = false;
    },
    ...mapActions(["deleteEvent", "toggleStarEvent", "toggleArchiveEvent"])
  },
  computed: {
    showActive() {
      return this.status === "processing";
    },
    events() {
      const result = [];
      const events = this.$store.getters.events;

      for (const i in events) {
        if (
          (events[i].active === this.showActive || this.status === "all") &&
          (events[i].name.toUpperCase().match(this.search.toUpperCase()) ||
            events[i].abbr.toUpperCase().match(this.search.toUpperCase()) ||
            events[i].description
              .toUpperCase()
              .match(this.search.toUpperCase()))
        ) {
          result.push(events[i]);
        }
      }
      return result;
    }
    // ...mapGetters(["events"])
  }
};
</script>

<style lang="less">
.event-view-card {
  margin: 2rem;
}
.list-content-description {
  max-width: 30rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.list-content-item {
  color: rgba(0, 0, 0, 0.45);
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
  margin-left: 40px;
  span {
    line-height: 20px;
  }
  p {
    margin-top: 4px;
    margin-bottom: 0;
    line-height: 22px;
  }
}
</style>
